<div class="landing">

  <!-- HERO -->
  <header class="hero">
    <span class="badge">
      <span class="dot"></span>
      <ng-container i18n="Page 'landing', availability badge@@landing_page.availability">Disponible maintenant</ng-container>
    </span>

    <div class="avatar">
      <img ngSrc="assets/img/isabella.png" width="300" height="300" priority alt="Isabella" />
    </div>

    <p class="name">Isabella</p>
    <p class="speciality" i18n="Page 'landing', speciality@@landing_page.speciality">Tarologie · Guidance intuitive</p>

    <h1 i18n="Page 'landing', headline@@landing_page.headline">Vous cherchez un <em>éclairage</em> sur ce que vous traversez ?</h1>

    <p class="intro" i18n="Page 'landing', intro@@landing_page.intro">Isabella vous accompagne avec une <strong>écoute bienveillante et sans jugement</strong> pour vous aider à comprendre les signes, vos émotions et les choix qui s'offrent à vous.</p>

    <ul class="stats">
      <li><b>98 %</b> <span i18n="Page 'landing', stat positive reviews@@landing_page.stat.reviews">d'avis positifs</span></li>
      <li><b>12 430</b> <span i18n="Page 'landing', stat consultations@@landing_page.stat.consultations">consultations</span></li>
      <li><b i18n="Page 'landing', stat first question value@@landing_page.stat.first_question.value">1ère</b> <span i18n="Page 'landing', stat first question label@@landing_page.stat.first_question.label">question offerte</span></li>
    </ul>

    <div class="confidential">
      <span class="lock" aria-hidden="true">
        <svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
          <rect x="4" y="10" width="16" height="11" rx="2.5" stroke="currentColor" stroke-width="1.6"/>
          <path d="M8 10V7a4 4 0 1 1 8 0v3" stroke="currentColor" stroke-width="1.6"/>
        </svg>
      </span>
      <div>
        <p class="c-title" i18n="Page 'landing', confidentiality title@@landing_page.confidential.title">Un espace confidentiel et sécurisant</p>
        <p class="c-text" i18n="Page 'landing', confidentiality text@@landing_page.confidential.text">Tout ce que vous partagez reste entre nous. Pas de jugement, juste une écoute pour avancer librement.</p>
      </div>
    </div>

    <a class="cta" routerLink="/chat" queryParamsHandling="preserve"
       i18n="Page 'landing', main call to action@@landing_page.cta">Commencer avec Isabella</a>
    <p class="cta-sub" i18n="Page 'landing', cta subtext@@landing_page.cta_sub">Échange instantané — bienveillant et sans jugement</p>
  </header>

  <!-- REASSURANCE -->
  <section class="card reassurance">
    <h2 i18n="Page 'landing', reassurance title@@landing_page.reassurance.title">Vous tournez en rond et personne ne semble vraiment vous comprendre ?</h2>
    <p i18n="Page 'landing', reassurance text@@landing_page.reassurance.text">Isabella cerne ce que vous traversez dès les premiers mots et vous offre un espace sécurisant, sans aucun jugement, pour déposer votre situation et retrouver la paix intérieure.</p>
    <a class="cta" routerLink="/chat" queryParamsHandling="preserve"
       i18n="Page 'landing', main call to action@@landing_page.cta">Commencer avec Isabella</a>
    <p class="cta-sub" i18n="Page 'landing', cta subtext@@landing_page.cta_sub">Échange instantané — bienveillant et sans jugement</p>
  </section>

  <!-- POUR VOUS SI -->
  <section class="for-you">
    <h2 i18n="Page 'landing', for-you title@@landing_page.foryou.title">Cette expérience est faite pour vous si…</h2>
    <ul class="checklist">
      <li i18n="Page 'landing', for-you item 1@@landing_page.foryou.0">vous êtes à un carrefour de vie, souvent sentimental, et avez besoin d'y voir clair</li>
      <li i18n="Page 'landing', for-you item 2@@landing_page.foryou.1">vous préférez un échange discret et instantané, à votre rythme</li>
      <li i18n="Page 'landing', for-you item 3@@landing_page.foryou.2">vous avez besoin de conseils concrets et applicables, pas seulement de prédictions</li>
      <li i18n="Page 'landing', for-you item 4@@landing_page.foryou.3">vous cherchez une guidance douce, bienveillante et sans jugement</li>
      <li i18n="Page 'landing', for-you item 5@@landing_page.foryou.4">vous voulez comprendre les énergies qui vous entourent grâce au Tarot et à votre thème astral</li>
    </ul>
  </section>

  <!-- CE QUE VOUS RECEVEZ -->
  <section class="card receive">
    <h2 i18n="Page 'landing', receive title@@landing_page.receive.title">Ce que vous allez recevoir</h2>
    <p i18n="Page 'landing', receive text@@landing_page.receive.text">Une guidance à 360° qui croise votre thème astral et le Tarot. Isabella décrit votre situation avec une justesse désarmante, puis vous oriente vers des choix clairs et apaisants, dans une grande douceur et un respect total de votre rythme.</p>
  </section>

  <!-- COMMENT ÇA MARCHE -->
  <section class="how">
    <h2 i18n="Page 'landing', how-it-works title@@landing_page.how.title">Comment ça marche</h2>
    <ol class="steps">
      <li>
        <span class="num">1</span>
        <p i18n="Page 'landing', how-it-works step 1@@landing_page.how.0">Vous posez votre question dans le chat — en toute confidentialité, à votre rythme, sans avoir à parler de vive voix.</p>
      </li>
      <li>
        <span class="num">2</span>
        <p i18n="Page 'landing', how-it-works step 2@@landing_page.how.1">Isabella étudie votre thème astral et tire les cartes — elle cerne votre situation avec précision et bienveillance.</p>
      </li>
      <li>
        <span class="num">3</span>
        <p i18n="Page 'landing', how-it-works step 3@@landing_page.how.2">Vous recevez une lecture claire, des conseils concrets, et la paix de pouvoir avancer sereinement.</p>
      </li>
    </ol>
  </section>

  <!-- POUR QUELS SUJETS -->
  <section class="subjects">
    <h2 i18n="Page 'landing', subjects title@@landing_page.subjects.title">Pour quels sujets ?</h2>
    <ul class="chips">
      <li i18n="Page 'landing', subject 1@@landing_page.subjects.0">Amour &amp; sentimental</li>
      <li i18n="Page 'landing', subject 2@@landing_page.subjects.1">Choix de vie</li>
      <li i18n="Page 'landing', subject 3@@landing_page.subjects.2">Thème astral</li>
      <li i18n="Page 'landing', subject 4@@landing_page.subjects.3">Tarot</li>
      <li i18n="Page 'landing', subject 5@@landing_page.subjects.4">Avenir professionnel</li>
      <li i18n="Page 'landing', subject 6@@landing_page.subjects.5">Guidance spirituelle</li>
      <li i18n="Page 'landing', subject 7@@landing_page.subjects.6">Alignement personnel</li>
    </ul>
  </section>

  <!-- AVIS -->
  <section class="reviews">
    <h2 i18n="Page 'landing', reviews title@@landing_page.reviews.title">Elle leur a apporté la clarté</h2>
    <p class="reviews-meta">
      <span>12 430 </span><span i18n="Page 'landing', reviews consultations@@landing_page.reviews.consultations">consultations</span>
      · 98 % <span i18n="Page 'landing', reviews positive@@landing_page.reviews.positive">d'avis positifs</span>
    </p>
    <div class="avatars">
      <img ngSrc="assets/img/avatar.png" width="60" height="60" alt="" />
      <img ngSrc="assets/img/avatar.png" width="60" height="60" alt="" />
      <img ngSrc="assets/img/avatar.png" width="60" height="60" alt="" />
    </div>
    <blockquote i18n="Page 'landing', review quote@@landing_page.reviews.quote">« Isabella a parfaitement compris ma situation et l'a décrite telle quelle. Je vais suivre ses conseils, un grand merci à elle. »</blockquote>
    <a class="cta" routerLink="/chat" queryParamsHandling="preserve"
       i18n="Page 'landing', main call to action@@landing_page.cta">Commencer avec Isabella</a>
    <p class="cta-sub" i18n="Page 'landing', cta subtext@@landing_page.cta_sub">Échange instantané — bienveillant et sans jugement</p>
  </section>

  <!-- FOOTER -->
  <footer class="legal">
    <a routerLink="/terms" i18n="Page 'landing', terms link@@landing_page.terms">Conditions générales d'utilisation</a>
    <!-- rouvre le bandeau de consentement (consentmanager.net), comme le pied de page de mon.astrocenter.fr -->
    <a href="?cmpscreen=1" rel="nofollow" (click)="manageCookies($event)" i18n="Page 'landing', cookie settings link@@landing_page.cookies">Gestion des cookies</a>
  </footer>

</div>
